import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Table from "react-bootstrap/Table";
import Card from "react-bootstrap/Card";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import CreatableSelect from 'react-select/creatable';
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import {
	getClientMetrics,
	updateMetricOrder,
	// getCategories,
	createMetric,
	createCategory,
	getAllMetricsByCategory,
	updateLocalMetricOrder,
	// selectCategoryById
	// updateMetricGroupings,
	deleteCategory,
	deleteMetric,
	// categorizeAndEditMetric,
	updateMetric,
	selectAllMetrics
} from "../../state/metricListSlice";
import classes from "./MetricList.module.css";
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col";
import Tooltip from "react-bootstrap/Tooltip";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';


import { getAllClients, selectAllClients } from "../users/usersSlice"
// import { getAllEventsTemplates } from "../EventsView/eventsViewSlice";
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import useApiStatusDispatch from "../../hooks/useApiStatusDispatch";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";



const GymMetricList = () => {

	const userID = useSelector((state) => state.users.current_user?.user_id_number);

  const dispatch = useDispatch()
  const statusDispatch = useApiStatusDispatch();


	const [metricSort, setMetricSort] = useState(false)
	const [isLoading, setIsLoading] =useState(false)
	const [isIntegrated, setIsIntegrated] = useState(false);
	const [integrationId, setIntegrationId] = useState(0);
	const [itemName, setItemName] = useState("");
	const [itemDesc, setItemDesc] = useState("");
	const [itemCategory, setItemCategory] = useState('')
	const [categoryPlaceholder, setCategoryPlaceholder] = useState('')
	const [isSelectLoading, setIsSelectLoading] = useState(false) //for createable select 
	const [showAddCategory,setShowAddCategory] = useState(false)
	const [categoryName,setCategoryName] = useState('')
	const [assessmentID, setAssessmentID] = useState("")

	const [defaultassessment, setDefaultAssessment] = useState(0);
	const [editToggle, setEditToggle] = useState(false)
	const [clients, setClients] = useState("single");
	const [toDelete, setToDelete] = useState({})

	const [orderDiff, setOrderDiff] = useState({})
	const [dragDisabled, setDragDisabled] = useState(true)

	//gets all metrics upon client select or dispatch
	useEffect(() => {
		setIsLoading(true)
		let include_progress_data=0
		let include_empty_groups=1
		let	client_Id = userID
		let type = 'client'

		const payload = {
			type,
			client_Id,
			include_progress_data,
			include_empty_groups
		}
		dispatch(getAllMetricsByCategory(payload)).then(() => {
			setIsLoading(false)
		})
	}, [])

  // const metrics = Object.values(useSelector((state) => state.metrics.entities))
	const metrics = useSelector(selectAllMetrics)
	const categories = Object.values(useSelector((state) => state.metrics.categories.entities))

	const metricIntegrations = [{ text: "One Rep Max", value: 1 }];

	const resetFormState = () => {
		setItemName("");
		setItemDesc("");
		setIsIntegrated(false);
		setIntegrationId(0);
		setCategoryPlaceholder('')
	};

	const setAssessmentToEdit = (assessment) => {
		setAssessmentID(assessment.assessment_id);
		setItemName(assessment.assessment_name);
		setItemDesc(assessment.description);
		setIntegrationId(assessment.integration_id);
		setCategoryPlaceholder(assessment.categorization)
		setIsIntegrated(assessment.integration_id == 0 ? false : true);
	};


	const [showAddmodal, setShowAddModal] = useState(false);
	const handleAddClose = () => {
		setShowAddModal(false);
		resetFormState();
	};
	const handleAddShow = () => {
		setShowAddModal(true)
	};

	//Edit Modal
	const [showEditModal, setShowEditModal] = useState(false);
	const handleEditClose = () => {
		setShowEditModal(false);
		resetFormState();
	};
	const handleEditShow = (categorization) => {
		setCategoryPlaceholder(categorization)
		setItemCategory({label:categorization})
		setShowEditModal(true);
	}

	// Manage Categories Modal 
	const [showCategorymodal, setShowCategoryModal] = useState(false);
	const handleCategoryClose = () => {
		setShowCategoryModal(false);
		setShowAddCategory(false)
		resetFormState();
	};
	const handleCategoryShow = () => setShowCategoryModal(true);

		//finds category id then either dispatches one 'addMetric' or many for every client and default
	// depending on if 'add metric to all clients' has been selected
	const addMetric = (e) => {
		e.preventDefault()
		let category_id;
		if(itemCategory === ''){
			category_id = 0
		} else if(itemCategory.value !== null) {
			category_id = itemCategory.value
		} else {
			category_id = (categories.find(category => category.category === itemCategory.label)).category_id
		}
		let preferred_order = metrics.length // add new metric to bottom of list on reload
		let clientName = "default" // AKA type
		let payload;
			payload = {
					clientName,
					category_id,
					itemName,
					itemDesc,
					integrationId,
					preferred_order
			};
			statusDispatch(createMetric(payload), "metric","create")
		handleAddClose()
	};

	//maps the list of categories for the select menu
	const mapCategoriesToSelectObjects = array => (
		(array?.reverse()).map(c => {
			return {
				label:c.category,
				value:c.category_id
			}
		})
	)

	const handleAddCategory = (e) => {
		e.preventDefault()
		addCategory(categoryName)
		setCategoryName('')

		setShowAddCategory(false)
	}

	//adds a category
	const addCategory = (inputValue) => {
		const payload = {
			inputValue
		};
		statusDispatch(createCategory(payload),"category","create")
	};

	//sets a selected category to state
	const handleOptionChange = (newValue) => {
		setItemCategory(newValue)
	};

	// when a user creates a new category, it sets a loading spinner for 1 second (to simulate updating the database)
	// then sets the state of selected category to the newly created category
	const handleOptionCreate = (inputValue) => {
		setIsSelectLoading(true)
		console.group('Option created');
		console.log('Wait a moment...');
		addCategory(inputValue)
		setTimeout(() => {
			setIsSelectLoading(false)
			let newCategory = {
				label: inputValue,
				value: null
			}
			setItemCategory(newCategory)
		}, 1000);
	};

	const editAssessmentFunc = () => {
		let category_id;
		if(itemCategory === ''){
			category_id = 0
		} else if(itemCategory.value) {
			category_id = itemCategory.value
		} else {
			category_id = (categories.find(category => category.category === itemCategory.label)).category_id
		}
		let	payload = {
			itemName,
			itemDesc,
			defaultassessment,
			clients,
			integrationId,
			assessmentID,
			category_id
		};
		dispatch(updateMetric(payload))
		.then(() => {
			setEditToggle(!editToggle)
			handleEditClose();
			setCategoryPlaceholder('')
		})


	};


		//checks if category is used for any existing metric, if so notifies the user. if not used, proceeds
	// to delete the category
	const deleteCategoryHandler = (id,name) => {
		let isEmpty = true
		metrics.forEach(metric => {
			if(metric.categorization === name){
				isEmpty=false
			}
		})
		if(!isEmpty){
			window.alert("You must delete or move all metrics in this Category before deleting it")
		} else {
			let payload={category_id:id}
			statusDispatch(deleteCategory(payload),"category","delete")
		}
	}

	//upon the delete checkbox click, deep copies the toDelete list then either adds or removes the checked(or unchecked) metric
	const handleDeleteToggle =(id) => {
			let newToDelete = JSON.parse(JSON.stringify(toDelete))
		if(toDelete[id] !== undefined){
			delete newToDelete[id]
		} else {
			newToDelete[id] = id
		}
		setToDelete(newToDelete)
	}

	// when user clicks the garbage can icon, it finds client ID, notifies user then 
	// deletes each metric that is in the toDelete state and resets the toDelete state
	const handleDeleteMetrics = () => {

		if (window.confirm('Are you sure you want to delete the selected metrics and all the data associated with them?')) {
			Object.keys(toDelete).forEach(id => {
				let payload = {
					client_Id: userID,
					id
				}
				console.log('DELETE PAYLOAD: ', payload)
				statusDispatch(deleteMetric(payload), "metric", "delete")
			})
			setToDelete({})
		}
	}

	// when a user clicks the delete all checkbox, either unchecks everything if already checked
	// or checks everything if none or some metrics are checked
	const toggleDeleteAll = () => { 
		if(Object.keys(toDelete).length === metrics.length){
			setToDelete({})
		} else {
			let newToDelete = {}
			metrics.forEach(metric => (
				newToDelete[metric.metric_id] = metric.metric_id
			))
			setToDelete(newToDelete)
		}
	}

	// checks if a metric id is within the toDelete object
	const inDeleteList = (id) => {
			if(toDelete[id] !== undefined){
				return true
			} else {
				return false
			}
	}

	//saves the order of the dragged and dropped metric list
	const saveOrder = () => {
		const payload = {
			clientId: userID,
			orderDiff
		}
		dispatch(updateMetricOrder(payload)).then(() => {
			dispatch(getClientMetrics(payload));
		})
		setDragDisabled(true)
	}

	//sets the order of the metric list after a user drags and drops a metric
	function handleOnDragEnd(result) {
		const items = Array.from(JSON.parse(JSON.stringify(metrics))) //stringified to deep copy data
		const [reorderedItem] = items.splice(result.source.index, 1);
		items.splice(result.destination.index, 0, reorderedItem);
		if (!result.destination) return;
		const orderObj = Object.fromEntries(items.map((item, index) => [item.assessment_id, index]))
		dispatch(updateLocalMetricOrder({items, orderObj}))
		setOrderDiff(orderObj)
	}


	return (
		<div className={classes.AssessmentList}>
			<div className={classes.Header}>Master Default Metrics</div>
			<hr />
      <div className={classes.Subtext}>
			<p>These are the default metrics that will be given to every new trainer that is added to this gym account. The trainer can then edit these metrics as needed for their clients or leave them as is.</p>

						</div>
      <Card style={{ width: "100%", marginTop: 25 }}>
				<Row>
					<Col>
						<OverlayTrigger
								placement={"top"}
								overlay={
								<Tooltip id={`tooltip-top`}>
									Create or delete a category
								</Tooltip>
								}
							>
							<Button
								onClick={() => handleCategoryShow()}
								size="sm"
								style={{
									backgroundColor: "#C0C0C0",
									float: "right",
									border: "none",
									marginBottom: 10,
									fontWeight: "bold",
									fontSize: '32px',
									width:'30px',
									height:'28px',
									marginLeft: 10,
									display:'flex',
									justifyContent:'center',
									alignItems:'center',
									lineHeight:'15px',
									margin:"15px",
									padding:"10px"
								}}
								className={classes.manageCategoryButton}
							>
								<span style={{
									position:"relative",
									top:"-2px"
								}}>&#9881;</span>
							</Button>
						</OverlayTrigger>

						{dragDisabled ? (
							<Button
								onClick={() => setDragDisabled((prev) => !prev)}
								size="sm"
								style={{
									backgroundColor: "#F5365C",
									float: "right",
									border: "none",
									// marginBottom: 10,
									// marginRight: "10px",
									margin:"15px",
									fontWeight: "bold"
								}}
								className={classes.dragNDropBtn}
								disabled={metricSort}
							>
								Change Order
							</Button>
						) : (
								<Button
									onClick={() => saveOrder()}
									size="sm"
									style={{
										backgroundColor: "#F5365C",
										float: "right",
										border: "none",
										// marginBottom: 10,
										// marginRight: "10px",
										margin:"15px",
										fontWeight: "bold"
									}}
									className={classes.dragNDropBtn}
								>
									Save Order
								</Button>
							)
						}

						<Button
							onClick={() => handleAddShow()}
							size="sm"
							style={{
								float: "right",
								fontWeight: "bold",
								margin:"15px",
								background:"#5e72e4"
							}}
							className={`btn btn-success ${classes.addMetricGymButton}`}
						>
							Add Metric
						</Button>

					</Col>
				</Row>
					<Card.Body>

            {/* <tbody> */}
						{isLoading ? 
                <div style={{ display: 'flex', justify_content: 'center' }}>
                  <Spinner animation="border" role="status" variant="primary" >
                  </Spinner>
                </div> 
              : 
							<Table bordered hover className={classes.metricListTable}>
							<thead style={{ backgroundColor: "#172B4D", color: "#fff" }}>
								<tr>
									<th> Metric Name</th>
									<th>Description</th>
									<th>Category</th>
									<td style={{width:'70px'}}>
										<div className="d-flex align-items-center">
											<Form.Check
												onChange={toggleDeleteAll}
												checked={Object.keys(toDelete).length === metrics.length}
												type="checkbox"
												aria-label="check all"
											/>
											<Button 
												disabled={Object.keys(toDelete).length === 0}
												onClick={handleDeleteMetrics} 
												variant="danger"
												size="sm">
												<i className="fa fa-trash"/>
											</Button>
										</div>
									</td>
								</tr>
							</thead>
							<DragDropContext onDragEnd={handleOnDragEnd}>
							<Droppable droppableId="metricList">
							{(provided) => (
							<tbody className="metricList" {...provided.droppableProps} ref={provided.innerRef} style={dragDisabled ? { backgroundColor: 'white' } : { backgroundColor: '#efeaff' }}>
							{metrics?.map((val, index) => (
							<Draggable key={val?.metric_id} draggableId={val?.metric_id.toString()} index={index} isDragDisabled={dragDisabled}>
								{(provided) => (
									<tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                  				<td 
										onClick={() => {
											setAssessmentToEdit(val);
											handleEditShow(val?.categorization);
										}}
									>
                    <span className={classes.AssessmentName}>
                      {val?.assessment_name}
                    </span>
                  </td>
                  <td
										onClick={() => {
											setAssessmentToEdit(val);
											handleEditShow(val?.categorization);
										}}
									>{val?.description}</td>
                  <td
										onClick={() => {
											setAssessmentToEdit(val);
											handleEditShow(val?.categorization);
										}}
									>{val?.categorization}</td>
									<td>
										<Form.Check
											onChange={()=>handleDeleteToggle(val.metric_id)}
											checked={(inDeleteList(val.metric_id))}
											type="checkbox"
											aria-label="check all"
										/>
									</td>
								</tr>
								)}
								</Draggable>
							))}
							{provided.placeholder}
						</tbody>
						)}
					</Droppable>
				</DragDropContext>

										

            </Table>
				}
          </Card.Body>
      </Card>
					{/* Add modal */}
					<Modal show={showAddmodal} onHide={handleAddClose}>
						<Modal.Header closeButton>
							<Modal.Title className={classes.ModalTitle}>
								Add Metric
				</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<Form style={{ padding: 20 }}>
								<Form.Group>
									<Form.Label>Metric Name:</Form.Label>
									<Form.Control
										type="text"
										name="itemName"
										onChange={(e) => setItemName(e.target.value)}
										value={itemName}
									/>
								</Form.Group>
								<Form.Group>
									<Form.Label>Metric Description:</Form.Label>
									{/* <Form.Control
										type="text"
										name="itemDesc"
										onChange={(e) => setItemDesc(e.target.value)}
										value={itemDesc}
									/> */}
									<textarea 
									class="form-control" 
									name="itemDesc"
									onChange={(e) => setItemDesc(e.target.value)}
									value={itemDesc}
									></textarea>
								</Form.Group>
								<Form.Group>
									<Form.Label>Select or Create Category:</Form.Label>
									<CreatableSelect
										isClearable
										isDisabled={isSelectLoading}
										isLoading={isSelectLoading}
										onChange={(e) => handleOptionChange(e)}
										onCreateOption={(e) => handleOptionCreate(e)}
										options={mapCategoriesToSelectObjects(categories)}
										value={itemCategory}
									/>
								</Form.Group>

								<div style={{ display: "flex", alignItems: "center" }} onClick={() => setIsIntegrated((prev) => !prev)}>
									<Form.Check
										name="isIntegrated"
										type="checkbox"
										checked={isIntegrated}
										// onChange={() => setIsIntegrated((prev) => !prev)}
										label="Integrate this metric"
										style={{ marginRight: 10 }}
									/>
									<OverlayTrigger
										placement={"top"}
										overlay={
											<Tooltip id={`tooltip-top`}>
												Integrate metrics are special metrics that integrate into
												other features
						</Tooltip>
										}
									>
										<i
											className="fas fa-info-circle"
											style={{ color: "#525F7F" }}
										></i>
									</OverlayTrigger>
								</div>

								{isIntegrated && (
									<div style={{ margin: "10px 0px" }}>
										<select
											value={integrationId}
											onChange={(e) => {
												setIntegrationId(e.target.value);
											}}
										>
											<option value={0} selected>
												---
						</option>
											{metricIntegrations.map((metric) => (
												<option value={metric.value}>{metric.text}</option>
											))}
										</select>
									</div>
								)}
								{integrationId != "0" && (
									<div>
										<div className={classes.MetricsSubHeader}>
											Metric Integrations
					</div>
										<div className={classes.Subtext}>
											The maximum weight at which a person can perform one rep of
											an exercise. Integrates with % Max Calculator on workout
											creato
					</div>
									</div>
								)}
								<hr />
									<Button
										size="sm"
										style={{
											float: "right",
											fontWeight: "bold",
										}}
										className='btn btn-success'
										onClick={(e) => addMetric(e)}
									>
										Add to Defaults
									</Button>

							</Form>
						</Modal.Body>
					</Modal>
					{/* Edit modal */}
					<Modal show={showEditModal} onHide={handleEditClose}>
						<Modal.Header closeButton>
							<Modal.Title className={classes.ModalTitle}>
								Edit Metrics
				</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<Form style={{ padding: 20 }}>
								<Form.Group>
									<Form.Label>Metric Name:</Form.Label>
									<Form.Control
										type="text"
										name="itemName"
										onChange={(e) => setItemName(e.target.value)}
										value={itemName}
									/>
								</Form.Group>
								<Form.Group>
									<Form.Label>Metrics Description:</Form.Label>
									{/* <Form.Control
										type="text"
										name="itemDesc"
										onChange={(e) => setItemDesc(e.target.value)}
										value={itemDesc}
									/> */}
									<textarea 
										class="form-control" 
										name="itemDesc"
										onChange={(e) => setItemDesc(e.target.value)}
										value={itemDesc}
									></textarea>
								</Form.Group>
								<Form.Group>
									<Form.Label>Select or Create Category:</Form.Label>
									<CreatableSelect
										isClearable
										isDisabled={isSelectLoading}
										isLoading={isSelectLoading}
										onChange={(e) => handleOptionChange(e)}
										onCreateOption={(e) => handleOptionCreate(e)}
										options={mapCategoriesToSelectObjects(categories)}
										value={itemCategory}
										placeholder={categoryPlaceholder}
									/>
								</Form.Group>
								<div style={{ display: "flex", alignItems: "center" }}>
									<Form.Check
										name="isIntegrated"
										type="checkbox"
										checked={isIntegrated}
										onChange={() => {
											let newIntegrated = !isIntegrated;
											setIsIntegrated(newIntegrated);
											if (newIntegrated == false) {
												setIntegrationId(0);
											}
										}}
										label="Integrate this metric"
										style={{ marginRight: 10 }}
									/>
									<OverlayTrigger
										placement={"top"}
										overlay={
											<Tooltip id={`tooltip-top`}>
												Integrate metrics are special metrics that integrate into
												other features
						</Tooltip>
										}
									>
										<i
											className="fas fa-info-circle"
											style={{ color: "#525F7F" }}
										></i>
									</OverlayTrigger>
									
								</div>

								{isIntegrated && (
									<div style={{ margin: "10px 0px" }}>
										<select
											value={integrationId}
											onChange={(e) => setIntegrationId(e.target.value)}
										>
											<option value={0} selected>
												---
						</option>
											{metricIntegrations.map((metric) => (
												<option value={metric.value}>{metric.text}</option>
											))}
										</select>
									</div>
								)}
								{integrationId != "0" && (
									<div>
										<div className={classes.MetricsSubHeader}>
											Metric Integrations
					</div>
										<div className={classes.Subtext}>
											The maximum weight at which a person can perform one rep of
											an exercise. Integrates with % Max Calculator on workout
											creator
					</div>
									</div>
								)}
								

								<hr />
								<Button
									size="sm"
									// className={classes.ModalBtn}
									style={{float:'right'}}
									variant='primary'
									onClick={() => editAssessmentFunc()}
								>
									Edit Metric
				</Button>
							</Form>
						</Modal.Body>
					</Modal>
			{/* manage categories modal */}
			<Modal show={showCategorymodal} onHide={handleCategoryClose}>
				<Modal.Header closeButton>
					<Modal.Title className={classes.ModalTitle}>
						Manage Categories
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Table bordered hover>
						<thead style={{ backgroundColor: "#172B4D", color: "#fff" }}>
							<tr>
								<th>Category</th>
							</tr>
						</thead>
							<tbody> 
									{categories?.map(val => (
										<>
										{val.category === 'General' ? null :
								<tr>
										<td>{val?.category}
										<i
											className={[classes.DeleteIcon, "fa fa-times"].join(
												" "
											)}
											onClick={() => deleteCategoryHandler(val.category_id, val.category)}
											style={{float:"right"}}
										></i>
										</td>
								</tr>
										}
								</>
									))}
							</tbody>

					</Table>
					{showAddCategory ? 
						<Form style={{borderStyle:'solid', borderWidth:'1px', borderColor:'grey', borderRadius:'2px', padding:'10px'}}>
							<Form.Group controlId="formBasicEmail">
								<Form.Label>Create a category</Form.Label>
								<Form.Control type="text" value={categoryName} onChange={(e) => setCategoryName(e.target.value)}/>
							</Form.Group>
							<Button 
								variant="primary" 
								type="submit" 
								onClick={handleAddCategory}		 
								disabled={categoryName===''}	
							>
								Submit
							</Button>
						</Form>
					
					: 
					<Button
						onClick={() => setShowAddCategory(true)}	
					>Create a category</Button>}
				</Modal.Body>
			</Modal>

		</div>
	);
};
export default GymMetricList;
